import { makeStyles } from '@mui/styles';

import Colors from 'configs/Colors';

const useStyles = makeStyles(() => ({
  wrapBoxInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    '&.MuiAvatar-root': {
      width: 120,
      height: 120,
    },
  },
  text: {
    marginTop: 8,
    color: Colors.Grey10,
  },
  wrapRoleId: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    marginTop: 8,
  },
  roleText: {
    color: Colors.Grey10,
    textTransform: 'uppercase',
  },
  bulletSeparator: {
    color: Colors.Grey10,
  },
  idWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  idText: {
    color: Colors.Grey10,
  },
  copyButton: {
    padding: 0,
    minWidth: 'auto',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  wrapLocation: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 8,
  },
  wrapNameUserProfile: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignContent: 'center',
  },
  nickNameUserProfile: {
    marginLeft: 8,
  },
  buttonShareLink: {
    '&.MuiButton-root': {
      padding: '8px 16px',
      display: 'flex',
      alignItems: 'center',
      textTransform: 'capitalize',
      border: `1px solid ${Colors.Primary}`,
    },
  },
}));

export default useStyles;
